export default __webpack_public_path__ + "static/media/bank.3f9bf01b.png";